import React, { memo } from 'react'

import Text from './Text'

const HeaderLinkText = ({ label, ...restProps }) => {
  return (
    <Text
      color='text.primary'
      label={label}
      fontWeight={700}
      fontSize='1.25rem'
      sx={{ textDecoration: 'none' }}
      {...restProps}
    />
  )
}

export default memo(HeaderLinkText)
